import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { SliderControl, ToolbarIconButton } from '@/design-system'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'

export interface StudioFilmstripProps {
  cameraPosition: number
  onCameraPositionChange: (value: number) => void
  isEditMode: boolean
  onTogglePreview: () => void
}

const Root = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: 64,
  flexShrink: 0,
  padding: '0 var(--ds-space-5)',
  borderTop: '1px solid var(--ds-border)',
  backgroundColor: 'var(--ds-surface)',
})

// Equal flex-1 spacers on both sides of the slider so it's genuinely
// centered in the bar regardless of width, instead of a lone flex:1 item
// that hits its max-width and leaves dead space trailing after the button.
const Side = styled(Box)({
  flex: 1,
  display: 'flex',
  minWidth: 0,
})

/** Bottom strip — camera framing control and edit/preview toggle */
export function StudioFilmstrip({
  cameraPosition,
  onCameraPositionChange,
  isEditMode,
  onTogglePreview,
}: StudioFilmstripProps) {
  return (
    <Root>
      <Side />

      <Box width='100%' maxWidth={480} flexShrink={0}>
        <SliderControl
          label='Camera position'
          value={cameraPosition * 100}
          min={0}
          max={100}
          onChange={(v) => onCameraPositionChange(v / 100)}
          valueFormatter={(v) => `${Math.round(v)}%`}
        />
      </Box>

      <Side sx={{ justifyContent: 'flex-end' }}>
        <ToolbarIconButton
          icon={isEditMode ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
          label={isEditMode ? 'Preview' : 'Back to editing'}
          onClick={onTogglePreview}
        />
      </Side>
    </Root>
  )
}
